import { DesignWebpackBackend } from '@sas/react-svg';
import { getBundle } from './createUseTextLocalizer';
/**
 * Abstract I18next backend for loading message bundles with webpack.
 */
export default class WebpackBackend {
  type = 'backend';
  constructor() {}
  init(_services, _backendOptions, _i18nextOptions) {}
  async read(language, namespace, callback) {
    try {
      callback(null, await this.import(language, namespace));
    } catch (err) {
      callback(err, false);
    }
  }
  create(_languages, _namespace, _key, _fallbackValue) {}
}

/**
 * I18next backend to load default message bundles for nova-commons components.
 *
 * All apps should include this unless you have a VERY unique i18n use case.
 */
export class NovaWebpackBackend extends WebpackBackend {
  defaultProvider = true;
  async import(language, bundleName) {
    if (bundleName.startsWith('SASDesign-')) {
      return await new DesignWebpackBackend().import(language, bundleName);
    }
    if (language !== 'en') {
      // eslint-disable-next-line @sas/i18n/jsx-to-localize
      return Promise.reject('Only en is supported by NovaWebpackBackend');
    }
    const bundle = getBundle(bundleName);
    if (bundle) {
      return bundle;
    }

    // eslint-disable-next-line @sas/i18n/jsx-to-localize
    return Promise.reject(`Bundle'${bundleName}' not found in NovaWebpackBackend.`);
  }
}
//# sourceMappingURL=WebpackBackend.js.map